<cdx-slotted-modal
	(close)="close()"
	center="true"
	size="default"
	class="celebratory-modal"
	padding="none"
	verticalPadding="none"
>
	<div modal-header class="celebratory-modal__header"></div>
	<div modal-content class="celebratory-modal__body">
		<img [src]="rewardMessageContent.imageUrl" alt="Rewards Voucher" />
		<div>
			<edr-heading
				[level]="5"
				[text]="rewardMessageContent.title"
			/>
			<p [innerHTML]="rewardMessageContent.message"></p>
		</div>
	</div>
	<div modal-footer-primary class="celebratory-modal__footer">
		<button cdxButton cdkFocusInitial (click)="close()">{{ rewardMessageContent.ctaText }}</button>
	</div>
</cdx-slotted-modal>
